var path = 'src/app/ui/tick.html';
var html = "<i ng-show=isTrue() class=\"fa fa-check\"></i> <i ng-show=isFalse() class=\"fa fa-remove\"></i> <i ng-show=isNeither() class=\"fa fa-question\"></i> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/tick.html
// module id = 671
// module chunks = 0